import React from 'react';
import styled from 'styled-components';

const I = styled.i`
  font-size: 0.9em;
`;
export default ({ direction }) => <I className={`fa fa-chevron-${direction}`} />;
